"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcGeneratorMenu = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_link_constants_1 = require("../../atoms/bc-link/bc-link-constants");
var index_1 = require("../../../common/helpers/index");
var bc_menu_v2_constants_1 = require("./bc-menu-v2-constants");
var BcGeneratorMenu = (function () {
    function BcGeneratorMenu() {
    }
    BcGeneratorMenu.prototype.initMenu = function (config, mainMenu) {
        var configMenu = JSON.stringify(config);
        var menuConfig = JSON.parse(configMenu);
        this.createItemsmenu(menuConfig, mainMenu);
    };
    BcGeneratorMenu.prototype.createItemsmenu = function (menuConfig, mainMenu) {
        var _this = this;
        var ulElement = (0, index_1.createElement)({
            element: common_constants_1.BcCommonConstants.UL_TAG,
            props: {
                id: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS,
            },
            classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS],
        });
        var ul = mainMenu.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2)).appendChild(ulElement);
        var liClassList = [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2];
        menuConfig.listItemsMenu.forEach(function (submenu) {
            var aElement = ul.appendChild((0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.HREF_TAG,
                props: {
                    tabindex: '0',
                    role: common_constants_1.BcCommonConstants.BUTTON_TAG,
                    target: !submenu.target ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LINK_SELF : submenu.target,
                },
            }));
            var liElement = aElement.appendChild((0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.LI_TAG,
                props: {
                    title: submenu.title,
                    icon: submenu.icon,
                    'data-toogle': 'toogle',
                },
                classList: liClassList,
            }));
            _this.setConfigOptionsMenu(liElement, submenu, aElement);
        });
    };
    BcGeneratorMenu.prototype.setConfigOptionsMenu = function (liElement, item, aElement) {
        var _this = this;
        var configOptions = {
            megaMenu: function () { return _this.createMegaMenu(liElement, item.megaMenu, item.stroke); },
            isDisabled: function () {
                liElement.parentElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_DISABLED);
                aElement.removeAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TABINDEX);
            },
            href: function () { return liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ATTR_HREF, item.href); },
            active: function () {
                liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
                liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
            }
        };
        Object.keys(configOptions).forEach(function (key) {
            if (item[key]) {
                configOptions[key]();
            }
        });
        aElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            var allowedKeyCodes = [common_constants_1.BcCommonConstants.KEY_EVENT_ENTER, common_constants_1.BcCommonConstants.KEY_EVENT_SPACE];
            if (allowedKeyCodes.includes(event.code)) {
                _this.setkeyboardSupport(liElement);
            }
        });
        liElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.setClickItems(liElement, item.megaMenu, event);
        });
    };
    BcGeneratorMenu.prototype.setClickItems = function (liElement, subMenu, event) {
        var _this = this;
        var allActiveElements = document.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE, ", .").concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE));
        allActiveElements.forEach(function (element) {
            _this.setAccesibilityAriaFalse(element);
        });
        var returnEvent = {
            titleItem: liElement.getAttribute('title'),
        };
        if (!subMenu) {
            this.onDeleteClassActiveItems();
            this.onDeleteClassPressItems();
            this.onDeleteMegaMenu();
            liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        }
        var isMegamenu = event.target.closest(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
        if (isMegamenu === null) {
            this.onEventGenerator(returnEvent, event);
        }
    };
    BcGeneratorMenu.prototype.setAccesibilityAriaFalse = function (configli) {
        configli.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE);
        configli.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE);
    };
    BcGeneratorMenu.prototype.setkeyboardSupport = function (subMenu) {
        var _this = this;
        if (window.innerWidth >= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
            var allActiveElements = document.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE, ", .").concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE));
            allActiveElements.forEach(function (element) {
                _this.setAccesibilityAriaFalse(element);
            });
        }
        var megaMenu = subMenu.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
        if (megaMenu) {
            this.onToogleOpenCloseMegamenu(subMenu);
        }
        else {
            this.onDeleteClassPressItems();
            this.onDeleteClassActiveItems();
            subMenu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
        }
    };
    BcGeneratorMenu.prototype.createMegaMenu = function (liElement, megamenu, stroke) {
        var sectionElement = liElement.appendChild((0, index_1.createElement)({
            element: common_constants_1.BcCommonConstants.SECTION_TAG,
            classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2],
            children: [
                (0, index_1.createElement)({ element: common_constants_1.BcCommonConstants.HR_TAG }),
                (0, index_1.createElement)({
                    element: common_constants_1.BcCommonConstants.DIV_TAG,
                    classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_CONTAINER],
                }),
            ],
        }));
        if (stroke) {
            var sectionStroke = (0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.IMG_TAG,
                classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FOOTER_STROKE, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_STROKE],
                props: {
                    src: stroke,
                },
            });
            sectionElement.appendChild(sectionStroke);
        }
        var megaMenuContainer = sectionElement.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_CONTAINER));
        this.createColumn(megamenu, megaMenuContainer);
    };
    BcGeneratorMenu.prototype.createColumn = function (megamenu, megaMenuContainer) {
        var _this = this;
        megamenu.forEach(function (column) {
            var megaMenuContent = (0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.UL_TAG,
                classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_CONTENT],
            });
            _this.createGroup(megaMenuContent, column);
            megaMenuContainer.appendChild(megaMenuContent);
        });
    };
    BcGeneratorMenu.prototype.createGroup = function (megaMenuContent, column) {
        var _this = this;
        column.forEach(function (group) {
            var ulElement = (0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.UL_TAG,
                props: {
                    title: group.nameGroup,
                },
                classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_SUBGROUP],
            });
            var newMenuGroup = (0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.LI_TAG,
                classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_GROUPS],
                children: [ulElement],
            });
            megaMenuContent.appendChild(newMenuGroup);
            _this.createItems(ulElement, group.items);
        });
    };
    BcGeneratorMenu.prototype.createItems = function (ulElement, items) {
        var _this = this;
        items.forEach(function (item) {
            var spanElement = (0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                innerText: item.name,
            });
            var aElement = (0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.HREF_TAG,
                props: {
                    target: !item.target ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LINK_SELF : item.target,
                    href: item.href ? item.href : '#',
                },
                classList: [common_constants_1.BcCommonConstants.BC_LINK_CLASS, bc_link_constants_1.BcLinkConstants.LINK_DEFAULT],
                children: [spanElement],
            });
            var liElement = (0, index_1.createElement)({
                element: common_constants_1.BcCommonConstants.LI_TAG,
                classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ITEM],
                children: [aElement],
            });
            aElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                var returnEvent = _this.getReturnEvent(aElement);
                _this.onEventGenerator(returnEvent, event);
                var itemSubmenu = aElement.closest(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
                var megaMenu = aElement.closest(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
                _this.onDeleteClassActiveItems();
                _this.onDeleteClassPressItems();
                itemSubmenu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
                megaMenu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
                liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
                liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
            });
            ulElement.appendChild(liElement);
        });
    };
    BcGeneratorMenu.prototype.getReturnEvent = function (aElement) {
        var textLink = aElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG).innerText;
        var titleGroup = aElement.closest(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_SUBGROUP)).getAttribute('title');
        var titleItem = aElement.closest(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2)).getAttribute('title');
        return {
            textLink: textLink,
            titleGroup: titleGroup,
            titleItem: titleItem
        };
    };
    return BcGeneratorMenu;
}());
exports.BcGeneratorMenu = BcGeneratorMenu;
